<template>
  <el-dialog
    :visible.sync="state"
    :append-to-body="true"
    custom-class="error-dialog">
    <i class="error-dialog__icon fas fa-exclamation-circle"></i>
    <div class="error-dialog__message" v-html="error.message"></div>
    <div class="error-dialog__code">エラーコード： {{ error.code }}</div>

    <div class="error-dialog__action">
      <button class="error-dialog__button" @click="close()">トップページへ戻る</button>
    </div>
  </el-dialog>
</template>



<script>
import { mapState } from 'vuex'
import {
  Dialog,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/dialog.css'

export default {
  components: {
    'el-dialog': Dialog,
  },
  computed: {
    ...mapState({
      error: state => state.error.data,
    })
  },
  watch: {
    error: {
      handler(val) {
        if (this.error.status) {
          this.open()
        } else {
          this.close()
        }
      },
      deep: true
    },
  },
  data() {
    return {
      state: false,
    }
  },
  methods: {
    open() {
      this.state = true
    },
    close() {
      let root = this.$route.path.match(/gogatsu/) ?  this.config.path.root_gogatsu : this.config.path.root;

      this.state = false
      this.$store.commit('error/errorReset')
      this.$store.commit('canvas/itemsReset')
      this.$store.commit('cart/itemsReset')
      this.$router.push(root)
    },
  }
}
</script>



<style lang="scss">
.error-dialog {
  border-radius: 8px;
  text-align: center;
  width: 90%;
  @include breakpoints-min(sm) {
    width: 80%;
  }
  @include breakpoints-min(md) {
    width: 65%;
  }
  @include breakpoints-min(lg) {
    width: 512px;
  }

  &__message {
    line-height: 1.8;
  }
  &__code {
    display: inline-block;
    border-radius: 4px;
    background-color: $oc-red-1;
    line-height: 1;
    font-size: 11px;
    color: $oc-red-6;
    margin-top: 12px;
    padding: 8px 12px;
  }
  &__icon {
    font-size: 80px;
    text-align: center;
    line-height: 1;
    color: $oc-gray-4;
    margin-bottom: 20px;
  }

  &__action {
    margin-top: 40px;
  }
  &__button {
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    display: inline-block;
    appearance: none;
    transition: $transition;
    outline: none;
    border-radius: 999px;
    border: 1px solid $accent-color;
    background-color: $accent-color;
    font-size: 12px;
    text-align: center;
    color: #fff;
    width: 176px;
    padding-top: 16px;
    padding-bottom: 16px;
    @include hover() {
      border-color: $accent-color-hover;
      background-color: $accent-color-hover;
    }
    @include active() {
      border-color: $accent-color-active;
      background-color: $accent-color-active;
      color: #fff;
    }
  }

  .el-dialog {
    &__header {
      display: none;
    }
    &__body {
      padding: 40px 20px;
    }
  }
}

.app-gogatsu ~ .el-dialog__wrapper {
    .error-dialog {
        &__button {
            border: 1px solid $gogatsu-accent-color;
            background-color: $gogatsu-accent-color;
            color: #fff;
            @include hover() {
                border-color: $gogatsu-accent-color-hover;
                background-color: $gogatsu-accent-color-hover;
            }
            @include active() {
                border-color: $gogatsu-accent-color-active;
                background-color: $gogatsu-accent-color-active;
                color: #fff;
            }
        }
    }
}
</style>
